import React from 'react'
import CopyToClipboard from '../../../../utils/copy-to-clipboard'

const CaseNumber = ({ value }) => (
  <CopyToClipboard text={value}>{value}</CopyToClipboard>
)
export default CaseNumber
